export const SingleStoreViewConfig = Symbol.for('drizzle:SingleStoreViewConfig');
